export const OrderService = {
	reloadCarCar: 1,
	reloadCarTerminalCar: 2,
	intoPlukkStorage: 3,
	crossDock: 4,
	[null]: null,
}

const reloadCarCarFullName = process.env.REACT_APP_RELOAD_CAR_CAR__FULL_NAME ?? "Reload Car-Car";
const reloadCarTerminalCarFullName = process.env.REACT_APP_RELOAD_CAR_TERMINAL_CAR__FULL_NAME ?? "Reload Car-Terminal-Car";
const intoPlukkStorageFullName = process.env.REACT_APP_INTO_PLUKK_STORAGE__FULL_NAME ?? "Into Plukk Storage";
const crossDockFullName = process.env.REACT_APP_CROSS_DOCK__FULL_NAME ?? "Cross Dock";

const reloadCarCarHidden = process.env.REACT_APP_RELOAD_CAR_CAR__HIDDEN === "true" ? true : false;
const reloadCarTerminalCarHidden = process.env.REACT_APP_RELOAD_CAR_TERMINAL_CAR__HIDDEN === "true" ? true : false;
const intoPlukkStorageHidden = process.env.REACT_APP_INTO_PLUKK_STORAGE__HIDDEN === "true" ? true : false;
const crossDockHidden = process.env.REACT_APP_CROSS_DOCK__HIDDEN === "true" ? true : false;

export const OrderServicesHidden = {
	[OrderService.reloadCarCar]: reloadCarCarHidden,
	[OrderService.reloadCarTerminalCar]: reloadCarTerminalCarHidden,
	[OrderService.intoPlukkStorage]: intoPlukkStorageHidden,
	[OrderService.crossDock]: crossDockHidden,
}

export const OrderServiceNames = {
	[OrderService.reloadCarCar]: reloadCarCarFullName,
	[OrderService.reloadCarTerminalCar]: reloadCarTerminalCarFullName,
	[OrderService.intoPlukkStorage]: intoPlukkStorageFullName,
	[OrderService.crossDock]: crossDockFullName,
}

export const OrderServiceChoices = [
	{id: OrderService.reloadCarCar, name: OrderServiceNames[OrderService.reloadCarCar]},
	{id: OrderService.reloadCarTerminalCar, name: OrderServiceNames[OrderService.reloadCarTerminalCar]},
	{id: OrderService.intoPlukkStorage, name: OrderServiceNames[OrderService.intoPlukkStorage]},
	{id: OrderService.crossDock, name: OrderServiceNames[OrderService.crossDock]},
]

export const OrderServices = {
	[OrderService.reloadCarCar]: {
		full_name: reloadCarCarFullName,
		short_name: process.env.REACT_APP_RELOAD_CAR_CAR__SHORT_NAME ?? "C-C",
	},
	[OrderService.reloadCarTerminalCar]: {
		full_name: reloadCarTerminalCarFullName,
		short_name: process.env.REACT_APP_RELOAD_CAR_TERMINAL_CAR__SHORT_NAME ?? "C-T-C",
	},
	[OrderService.intoPlukkStorage]: {
		full_name: intoPlukkStorageFullName,
		short_name: process.env.REACT_APP_INTO_PLUKK_STORAGE__SHORT_NAME ?? "Plukk",
	},
	[OrderService.crossDock]: {
		full_name: crossDockFullName,
		short_name: process.env.REACT_APP_CROSS_DOCK__SHORT_NAME ?? "CD",
	},
}

export const OrderServicesActiveNames = Object.fromEntries(
	Object.entries(OrderServiceNames)
	.filter(([k, _]) => !OrderServicesHidden[k])
)

export const OrderServiceActiveChoices = OrderServiceChoices
	.filter(service => !OrderServicesHidden[service.id]);
